import { createFileRoute, redirect } from '@tanstack/react-router';
import { paths } from '@/routes/paths';

// The screenshot-import flow is backed by the GPU inference service
// (SAM 3 + LaMa). Production currently ships the HTML import path and
// no inference service is deployed, so this route would 5xx for users.
// Redirect to the unified create-email surface until inference comes online.
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/email-img-upload')({
  beforeLoad: () => {
    throw redirect({ to: paths.dashboard.emailCreate });
  },
});
